export default {"src":"/_next/static/media/arrow-down.964ee6c8.svg","height":10,"width":15,"blurWidth":0,"blurHeight":0};